/**
 * Klasse AKTE_HUB_CLICK_NOT_CHAT — der offene Akt ist eine eigene Klick-Fläche.
 *
 * Polar:
 *   VERBOTEN: Akt öffnen erzwingt ARKO/Composer oder übernimmt eine Akte, die
 *   nicht in der bereits sichtbaren PB-/Mitgliedschaftsliste liegt.
 *   ERLAUBT: Sichtbare Akte öffnet den Rahmen (Verlauf, Dokumente, Fristen,
 *   Chats, Notiz). ARKO bleibt ein optionaler, ausdrücklich gewählter Weg.
 *   Chats nur Store-Räume mit derselben akte_id.
 *
 * Ohne sichtbare Akte-ID bleibt der Hub fail-closed. Fristen werden zusätzlich
 * nur mit dem gespeicherten Aktenpfad geladen, weil `portal_fristen` diesen Pfad
 * (noch) als Scope-Schlüssel verwendet.
 */

export const PORTAL_AKTE_HUB_CLASS = 'AKTE_HUB_CLICK_NOT_CHAT' as const;

export const PORTAL_AKTE_HUB_TABS = [
  { id: 'beteiligte', label: 'Beteiligte' },
  { id: 'dokumente', label: 'Dokumente' },
  { id: 'fristen', label: 'Fristen' },
  { id: 'schreiben', label: 'Schreiben' },
] as const;

export type PortalAkteHubTab = (typeof PORTAL_AKTE_HUB_TABS)[number]['id'];

export type PortalAkteHubSelection = {
  id: string;
  nc_path?: string | null;
};

/** Nur Akten aus der bereits sichtbaren Liste dürfen Hub-Inhalt liefern. */
export function resolveVisiblePortalAkteForHub<T extends PortalAkteHubSelection>(
  visibleAkten: readonly T[],
  requestedId?: string | null,
): T | null {
  const id = requestedId?.trim() ?? '';
  if (!id) return null;
  return visibleAkten.find((akte) => akte.id.trim() === id) ?? null;
}

/** Fristen nie kundenweit laden, wenn am Akt weder ID noch Pfad-Scope da ist. */
export function portalAkteHubFristenPath(
  akte?: PortalAkteHubSelection | null,
): string | null {
  if (!akte?.id?.trim()) return null;
  const path = akte.nc_path?.trim() ?? '';
  return path || null;
}

/** Rohe Storage-/NC-Pfade — nie in der Kundenfläche. */
const PORTAL_INTERNAL_STORAGE_PATH_RE =
  /(?:^|\/)Mandanten(?:\/|$)|portal-documents|\bkz_[a-z0-9_]+|nextcloud|remote\.php\/dav/i;

export function isPortalInternalStoragePath(raw?: string | null): boolean {
  return PORTAL_INTERNAL_STORAGE_PATH_RE.test(String(raw || ''));
}

/** Kundenfläche: Storage-Pfad nie anzeigen. Interner Pfad bleibt für DnD. */
export function portalAkteCustomerFolderHint(ncPath?: string | null): string {
  return String(ncPath || '').trim() ? '' : 'Noch kein Ordner';
}
